import React from 'react';
import PropTypes from 'prop-types';
import './style';


const HorizontalTab = (props) => {
  const {
    tabs,
    onSelect,
    selectedTab,
    className,
    children,
  } = props;
  return(
    window.innerWidth <= 768 ? ( 
    <div className={`flex w-full relative ${className}`}>
      <div className='tab-wrapper flex gap-6 overflow-x-auto'> 
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={` px-2 tab-label label-16 text-grey-70 ${selectedTab === tab ? 'selected':''}`}
            onClick={() => onSelect(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      <div className="content flex">
        {children}
      </div>
    </div>
    ) : (
       <div className={`flex gap-6 ${className}  w-full border-b-2 border-grey-5 flex gap-6 `} >
      <div className='tab-wrapper flex flex-1 gap-6'  > 
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={` px-2 tab-label label-16 text-grey-70 ${selectedTab === tab ? 'selected':''}`}
            onClick={() => onSelect(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      <div className="content flex">
        {children}
      </div>
    </div>
    )
  );
};

HorizontalTab.propTypes ={
  tabs:PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect:PropTypes.func.isRequired,
  selectedTab:PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};
HorizontalTab.defaultProps = {
  tabs: [],
  selectedTab: null,
  className: '',
  children: null,
  onSelect: () => {},
};

export default HorizontalTab;
